import React, { forwardRef, useImperativeHandle } from 'react';
import { ButtonSelector, useLang } from '@manulife/mux';
import { Controller, useFormContext } from 'react-hook-form';
import LABELS from '../../../assets/labels';
import NumberConstants from '../../../assets/appStyledComponents/numberConstant.json';

const IrSmokingStatus = forwardRef(({ detailFor }, ref) => {
    const selectedLang = useLang();
    const { control } = useFormContext(); // retrieve all hook methods
    const { num300 } = NumberConstants;
    const name = `${detailFor}.irSmokingStatus`;
    const focusSmokingStatus = () => {
        // focus on first button of the smoking status      
        const element = document.getElementById(`${name}-0`);
        if (element) {
            element.focus();
        }
    };
    
    // Expose the focusSmokingStatus function via the ref
    useImperativeHandle(ref, () => ({
        focus: focusSmokingStatus
    }));

    return (
        <Controller
            control={control}
            name={name}
            rules={{
                required: LABELS.errors.required.irSmokingStatus[detailFor][selectedLang]
            }}
            render={({
                field: { onChange, onBlur, value, name },
                fieldState: { error },
            }) => (
                <ButtonSelector
                    id={name}
                    label={LABELS.question5[selectedLang][detailFor].question}
                    ariaLabel={LABELS.question5[selectedLang][detailFor].ariaLabel}
                    ariaRequired={true}
                    values={LABELS.question5[selectedLang].options}
                    verticalStackingBreakPoint={num300}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    errors={error && [{ id: `error-${name}`, isError: true, msg: error.message }]}
                    callouts={false}
                />
            )}
        />
    )
});

export default IrSmokingStatus;